<zef-dialog
  [open]="state.open"
  [autoFocus]="false"
  (closeTrigger)="onClose$.next()">
  <div class="__content">

    <zef-scrollbar maxHeight="60vh">
      <zui-form-section separator="none">
        <zui-project-env-edit-form
          #formRef
          class="__form"
          (submit)="onUpdate$.next()"
          [state]="state.formState">

          @if (state.canReveal) {
            <div class="__reveal" contentSlot>
              <zef-progress-error [key]="revealKey">
                <button
                  class="__reveal-button  c-button--smaller"
                  type="button"
                  mat-button
                  color="accent"
                  [matTooltip]="'The current value is hidden. Saving replaces it with whatever you type here. Revealing it first requires re-authorization.'"
                  [matTooltipPosition]="'above'"
                  [matTooltipClass]="'c-zerops-tooltip'"
                  (click)="onReveal$.next()">
                  <mat-icon fontSet="material-icons-outlined">visibility</mat-icon>
                  <span>Reveal</span>
                </button>
              </zef-progress-error>
            </div>
          }

        </zui-project-env-edit-form>
      </zui-form-section>
    </zef-scrollbar>

    <div class="__buttons">
      <div class="__buttons-grid">

        <div>
          <zef-progress-error full [key]="updateKey">
            <button
              class="c-button--full"
              color="accent"
              mat-flat-button
              (click)="formRef.triggerSubmit()"
              type="button">
              {{ state.formState.value.type === projectEnvTypes.System
                ? state.projectEnvEditDialogItemTranslations.titleGeneratedEnvActionButton
                : state.projectEnvEditDialogItemTranslations.titleCustomEnvActionButton
              }}
            </button>
          </zef-progress-error>
        </div>

        <div>
          <button
            (click)="onClose$.next()"
            class="c-button--full"
            type="button"
            mat-button>
            <span transloco="general.close"></span>
          </button>
        </div>

      </div>
    </div>

  </div>
</zef-dialog>
